export default "__VITE_ASSET__BdVzmxRU__"